<template>
  <custom-dialog width="800px" :title="model.title" class="protocol-icon-dialog" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <div class="icon-container">
        <div @click="onSel(index)" class="icon-item" v-for="(item, index) in iconList" :key="index" :class="{ active: curIndex === index }">
          <div class="icon-content">
            <img :src="getAttachUrl(item)" alt="" class="img" />
          </div>
        </div>
        <div class="icon-item upload-item" @click="onSel(iconList.length)" :class="{ 'has-img': previewImgSrc, active: previewImgSrc && curIndex === iconList.length }">
          <div class="upload-content" v-if="!previewImgSrc">
            <input type="file" ref="file" class="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="fileChange" />
            <i class="el-icon-plus center"></i>
          </div>
          <div class="icon-content" v-else>
            <img :src="previewImgSrc" class="img" alt="" />
            <span class="action-content">
              <div class="mask"></div>
              <i class="el-icon-delete btn" @click.stop="clearImg"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button :disabled="curIndex === ''" type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    productCode: String,
  },
  data() {
    return {
      // 部件图标列表
      iconList: [],
      bizType: 'iot.component.icon',
      previewImgSrc: '',
      curIndex: '',
      previewFile: null,
    };
  },
  mounted() {
    this.getOssConfig();
    this.getIconList();
  },
  methods: {
    // 获取oss配置
    getOssConfig: function () {
      const folder = this.$getUploadFolder(this.bizType);
      this.$getJSON(apis.ossUpload, { folder }).then((res) => {
        this.ossConfig = res.data;
      });
    },
    onSel(index) {
      if (this.curIndex === index) {
        this.curIndex = '';
        return;
      }
      if (index === this.iconList.length) {
        if (this.previewImgSrc) {
          this.curIndex = index;
        } else {
          this.triggerFile();
        }
      } else {
        this.curIndex = index;
      }
    },
    triggerFile() {
      this.$refs.file.click();
    },
    fileChange() {
      const file = this.$refs.file.files[0];
      const reader = new FileReader();
      const ctx = this;

      this.previewFile = file;
      // 新建 FileReader 对象
      reader.onload = function () {
        // 当 FileReader 读取文件时候，读取的结果会放在 FileReader.result 属性中
        ctx.previewImgSrc = reader.result;
        ctx.curIndex = ctx.iconList.length;
      };
      // 设置以什么方式读取文件，这里以base64方式
      reader.readAsDataURL(file);
    },
    closeDialog() {
      this.visible = false;
    },
    onSave() {
      if (this.iconList.length) {
        if (this.curIndex < this.iconList.length) {
          this.$emit('confirm', this.iconList[this.curIndex]);
          this.closeDialog();
          return;
        }
      }
      // 先上传图片，再confirm
      const file = this.previewFile;
      this.$postOss(file, this.ossConfig).then(({ data }) => {
        data.bizType = this.bizType;
        this.$emit('confirm', data);
        this.closeDialog();
      });
    },
    getIconList() {
      this.$getJSON(apis.ComponentIconList, {}).then((res) => {
        const iconIds = res.data;
        this.$getAttachFileListType(iconIds, 'iot.component.icon').then((list) => {
          list.forEach((item) => {
            item.bizType = this.bizType;
          });
          this.iconList = list;
        });
      });
    },
    clearImg() {
      this.previewImgSrc = '';
      this.previewFile = '';
      this.curIndex = '';
    },
  },
};
</script>

<style lang="scss">
.protocol-icon-dialog {
  .icon-container {
    overflow: hidden;

    $itemR: 100px;
    .icon-item {
      float: left;
      width: $itemR;
      height: $itemR;
      margin-right: 30px;
      position: relative;
      margin-bottom: 15px;

      &.active {
        .icon-content {
          border: 1px solid #0d9ae0 !important;
        }
      }
      .img {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        max-width: 95%;
        max-height: 95%;
        z-index: 0;
      }

      .icon-content {
        position: relative;
        z-index: 0;
        width: 100%;
        height: 100%;
        border: 1px solid rgba(0, 0, 0, 0.3);
      }
    }

    .upload-item {
      &.has-img {
        &:hover {
          .action-content {
            display: block;
          }
        }
      }

      .upload-content {
        width: $itemR;
        height: $itemR;
        border: 1px dashed #c0ccda;
        position: relative;
        color: #8c939d;
        font-size: 28px;
        cursor: pointer;

        .file {
          display: none;
        }
      }

      .action-content {
        position: absolute;
        display: none;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        line-height: $itemR;
        text-align: center;
        > .mask {
          position: absolute;
          z-index: 0;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #000;
          opacity: 0.3;
        }
        .btn {
          position: relative;
          z-index: 100;
          cursor: pointer;
          color: #fff;
        }
      }
    }
  }
}
</style>
